<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Itinerari-esperienze/01_Pollino/01_3_Origini-avventura-umana/01_3_Grotta-Romito.jpg">
<div class="content">
    <h1>Pollino</h1>
    <h3>Alle origini dell’avventura umana</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a>Parco Nazionale del Pollino</a> > <a class="active">Alle origini dell’avventura umana</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div class="row schedaItinerario">
    <h2>Dalla Grotta del Romito a quella della Monaca</h2>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <img class="itinerario-foto" src="../../../assets/images/Itinerari-esperienze/01_Pollino/01_3_Origini-avventura-umana/01_3_Grotta-Romito.jpg">
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div id="map" class="mapInfo"></div>
    </div>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <p class="testoItinerario">
            Partiti da Scalea si sale sulle pendici dell’Orsomarso in direzione di Papasidero sulla SP3. 
            Percorsi circa 28 Km si devia sulla sinistra in direzione della Grotta del Romito che si raggiunge percorrendo circa 4 Km in ripida discesa.
            La grotta del Romito è uno dei luoghi più emozionanti che si possano visitare in Calabria. 
            Si tratta di un sito risalente al Paleolitico superiore, situato in località Nuppolara nel territorio di Papasidero, 
            che conserva una delle più antiche testimonianze dell’arte preistorica in Italia, fra le più rilevanti a livello europeo. 
            All’esterno della grotta, che si raggiunge dopo una bella passeggiata nel fresco bosco di querce, carpini e tigli, si trovano alcune incisioni rupestri, 
            tra le quali la più importante è un enorme graffito raffigurante due bovidi (Bos primigenius), 
            insieme a tracce di antiche sepolture, risalenti a 10.500 anni fa. Il sito è inoltre corredato di un Antiquarium dove sono esposti alcuni reperti.
            Proseguendo in direzione sud, superata Mormanno, si fa sosta a Morano Calabro, 
            uno dei borghi più belli d’Italia abbarbicato a forma di cono intorno al castello normanno-svevo, 
            da cui si gode un formidabile panorama che spazia da Serra del Prete al Pollino fino a Serra Dolcedorme (2267 m), la più elevata cima dell’Appennino meridionale. 
            <br>
            <br>
            Il viaggio riparte in direzione di San Basile, paese dell’olio, e di Saracena, comunità nota per il suo moscato presidio slow food. 
            Da qui si procede in direzione di Firmo, Lungro e Acquaformosa, paesi di origini arbëreshe, e da qui, dopo una emozionante discesa, 
            superati i magnifici borghi medievali di San Donato di Ninea e Policastrello, si raggiunge San Sosti. Procedendo in direzione sud, 
            lungo la Ciclovia dei Parchi, occorre proseguire svoltando a destra verso Sant’Agata d’Esaro/Belvedere Marittimo. 
            e da qui si devia in direzione di Sant’Agata d’Esaro. 
            Dal centro del paese occorre dirigersi verso nord e imboccare il sentiero che in meno di un Km conduce alle “mitiche” cavità. 
            La Grotta della Monaca e quella del Tesauro, oltre alle miniere preistoriche tra le più antiche testimonianze dell’attività estrattiva in Europa, 
            costituiscono un sito di notevole importanza speleo-archeologica. Situata nell’alta valle del fiume Esaro, a soli 10 Km dalle sponde del Tirreno, 
            in un ambiente naturale molto affascinante con balze rocciose e dirupi su di una profonda incisione valliva, 
            la Grotta della Monaca si sviluppa nei calcari dolomitici per 355 m attraverso gallerie, cunicoli e sale, tra cui quella dei “pipistrelli”. 
            Il Centro visita introduce ai tre percorsi di visita consentiti, breve, medio e lungo, che richiedono rispettivamente 54, 75 e 105 minuti. 
            Un’esperienza molto coinvolgente e appassionante. 
        </p>
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div class="row">
            <div class="col">
                <h5>Percorso:</h5>
            </div>
            <div class="col right">
                <h5> in bici</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Difficoltà:</h5>
            </div>
            <div class="col right">
                <h5>elevata</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Lunghezza:</h5>
            </div>
            <div class="col right">
                <h5>183 Km</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Giorni:</h5>
            </div>
            <div class="col right">
                <h5>3</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Salita:</h5>
            </div>
            <div class="col right">
                <h5>4200 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Discesa:</h5>
            </div>
            <div class="col right">
                <h5>4200 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di Partenza:</h5>
            </div>
            <div class="col right">
                <h5>Scalea</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di arrivo:</h5>
            </div>
            <div class="col right">
                <h5>Scalea</h5>
            </div>
        </div>
        <div class="divider"></div>
    </div>
</div>
<br>
<br>
<div class="divider2">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-7 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco Nazionale del Pollino.</p>
    </div>
    <div class="col-1 col-xl-1">
        <img src="../../../assets/images/04_Pollino/logo-pollino.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sui sentieri dei<br />"Patriarchi"</h1>
                        <a (click)="goToPatriarchi()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Lungo le strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goTo()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Alle origini<br />dell'avventura<br />umana</h1>
                        <a (click)="goToAvventuraUmana()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-12 col-xl-3 four" id="four">
            <div class="card four">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Viaggio nella<br />cultura<br />arberëshe</h1>
                        <a (click)="goToCulturaArbereshe()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 five" id="five">
            <div class="card five">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Cammini di<br />spiritualità e<br />natura</h1>
                        <a (click)="goToSpiritualitaENatura()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 six" id="six">
            <div class="card six">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Percorsi<br />di gusto</h1>
                        <a (click)="goToPercorsiDiGusto()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider2">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>
